module.exports = __webpack_public_path__ + "img/mechanic-icon.6c70e662.svg";